import {
  MessageSquare, FileText, Mail, Layout,
  Search, Globe,
} from 'lucide-react';

// ─── ICON MAP ───────────────────────────────────────────────────────────────

export const ICON_MAP = {
  'message-square': MessageSquare,
  'file-text': FileText,
  'mail': Mail,
  'layout': Layout,
  'search': Search,
  'globe': Globe,
};

// ─── MODE DEFINITIONS ───────────────────────────────────────────────────────
// Each mode's `color` is a per-mode accent that carries channel identity: it is
// deliberately NOT a theme.js token (one of the two documented exemptions).

// Comma-separated mode IDs to disable (button visible but not clickable).
// Set in Cloudflare Pages dashboard (prod) or .env (local override).
const DISABLED_MODE_IDS = (process.env.REACT_APP_DISABLED_MODES || '')
  .split(',')
  .map(s => s.trim())
  .filter(Boolean);

const MODE_DEFINITIONS = [
  { id: 'linkedin-post',  name: 'LinkedIn Post',  iconId: 'message-square', color: '#0A66C2', description: 'Post 80-250 parole con hook-body-CTA per engagement' },
  { id: 'blog-seo',       name: 'Blog SEO',        iconId: 'file-text',      color: '#F59E0B', description: 'Articolo 800-3500 parole ottimizzato SEO' },
  { id: 'email',          name: 'Newsletter',      iconId: 'mail',           color: '#EC4899', description: 'Email 250-400 parole con subject line efficace' },
  { id: 'landing',        name: 'Landing Page',    iconId: 'layout',         color: '#10A37F', description: 'Copy ad alta conversione multi-sezione' },
  // Keep this list in sync with SOCIAL_CHANNELS (constants/channels.js): it is
  // what the user reads on the mode card. Pinterest and YouTube were retired
  // from the picker by issue #32; X and TikTok were never selectable.
  { id: 'social',         name: 'Social',          iconId: 'globe',          color: '#FF6B35', description: 'Post nativo per Instagram e Facebook' },
];

export const MODES = MODE_DEFINITIONS.map(m => ({
  ...m,
  disabled: DISABLED_MODE_IDS.includes(m.id),
}));

export const HIDDEN_MODES = {};

export function getModeConfig(mode) {
  return MODES.find(m => m.id === mode) || HIDDEN_MODES[mode];
}

// ─── ESC BRAND ACCENT ───────────────────────────────────────────────────────
export const ESC_ACCENT = '#7843FF'; // Brian accent (was #FF0037)

